class Searchbar
    constructor: (el) ->
        @.$el = el
        @.$buttonEl = @.$el.querySelector '.searchbar__button'
        @.$inputEl = @.$el.querySelector '.searchbar__input .input__field'
        @.$resultsList = @.$el.querySelector '.searchbar__results ul'

        @.api = @.$el.dataset?.api ? false
        @.apiMethod = @.$el.dataset?.apiMethod ? 'GET'
        @.caseSensitiveSearch = @.$el.classList.contains 'searchbar--case-sensitive'
        @.minimalWordLength = @.$el.dataset?.mwl ? 2
        @.resultsOpen = @.$el.classList.contains 'searchbar--results-open'
        @.resultsPage = @.$el.dataset?.rp ? false
        @.termGetName = @.$el.dataset?.rptn ? 'st'
        @.termToResultsPage = @.$el.dataset?.rpt == 'true'
        
        
        @.InitEvents()
        @.$el.classList.add 'searchbar--bound'
        return

    AppendSearchResults: (results) ->
        self = @
        @.$resultsList.innerHTML = ""
        if results.length > 0
            results.forEach (result) ->
                if result.title
                    resultEntry = document.createElement 'li'
                    title = result.title
                    searchterm = self.$inputEl.value.toLowerCase()
                    if self.caseSensitiveSearch
                        searchtermIndex = title.indexOf(searchterm)
                    else
                        searchtermIndex = title.toLowerCase().indexOf(searchterm.toLowerCase())
                    if searchtermIndex >= 0
                        title = title.substring(0,searchtermIndex) + "<b>" + title.substring(searchtermIndex,searchtermIndex + searchterm.length) + "</b>" + title.substring(searchtermIndex + searchterm.length)
                    resultEntry.innerHTML = "
                        #{ if result.link then "<a href='#{ result.link }'>#{ title }</a>" else title  }
                    "
                    self.$resultsList.appendChild resultEntry
                return
            @.OpenSearchResults()
        else
            @.CloseSearchResults()
        return

    CloseSearchResults: ->
        @.$el.classList.remove 'searchbar--results-open'
        @.resultsOpen = false
        return

    GetSearchResults: (searchterm) ->
        self = @
        try
            body = {
                searchterm: searchterm
            }
            request = window.appUtils.XMLHttpRequest @.apiMethod, @.api
                , ->
                    if request.responseText && request.responseText != ""
                        try
                            results = []
                            response = JSON.parse request.responseText
                            if response.results
                                results = response.results
                            self.AppendSearchResults results
                            return
                        catch error
                            console.log "Fehler beim Versuch die Antwort der Suche-API zu verarbeiten"
                , ->
                    console.log "Bei der Anfrage an die Suche-API ist leider ein Fehler aufgetreten"
                    return
                , JSON.stringify body
        catch error
            console.log "Genereller Fehler beim Versuch eine Anfrage an die Suche-API zu senden"
        return
    
    GotoResultsPage: ->
        if @.ValidInputValue()
            @.CloseSearchResults()
            window.location.href = @.resultsPage + "#{ if @.termToResultsPage then "?#{ @.termGetName }=#{ encodeURIComponent(@.$inputEl.value) }" else "" }"
        return
    
    InitEvents: ->
        self = @
        if @.api
            @.$inputEl.addEventListener 'input', (e) ->
                if self.ValidInputValue()
                    self.GetSearchResults self.$inputEl.value
                else
                    self.CloseSearchResults()
                return
            @.$el.addEventListener 'searchbar-close-results', (e) ->
                self.CloseSearchResults()
                return
        if @.resultsPage
            @.$buttonEl.addEventListener 'click', (e) ->
                self.GotoResultsPage()
                return
            @.$inputEl.addEventListener 'keyup', (e) ->
                if e.key == 'Enter' || e.keyCode == 13
                    self.GotoResultsPage()
                return
        @.$el.addEventListener 'searchbar-set-search-term', (e) ->
            searchTerm = e.detail?.searchTerm ? false
            if searchTerm
                self.SetSearchTerm searchTerm
            return
        return

    OpenSearchResults: ->
        @.$el.classList.add 'searchbar--results-open'
        @.resultsOpen = true
        return
    
    SetSearchTerm: (searchTerm) ->
        @.$inputEl.value = searchTerm
        return
    
    ValidInputValue: ->
        return @.$inputEl.value.trim() != "" && @.$inputEl.value.trim().length >= @.minimalWordLength

BindSearchbars = ->
    document.querySelectorAll '.searchbar:not(.searchbar--bound)'
        .forEach (el) ->
            new Searchbar el
            return
    return

CloseSearchbarsBinder = ->
    if document.querySelectorAll('.searchbar--bound').length > 0
        window.addEventListener 'click', (e) ->
            if !e.target.classList.contains('searchbar__input') && !e.target.closest('.searchbar__results') && !e.target.closest('.searchbar')
                document.querySelectorAll '.searchbar'
                    .forEach (searchbarEl) ->
                        searchbarEl.dispatchEvent new CustomEvent 'searchbar-close-results', { bubbles: false }
                        return
            return
    return

SearchbarsBindComponents = ->
    BindSearchbars()
    CloseSearchbarsBinder()
    return

window.addEventListener 'bind-components', SearchbarsBindComponents